export default function(state = this.initialValue, action) {

    switch (action.type) {
        case this.selectedAction:
            return {...state, [action.payload.data.data.id]: action.payload.data.data};
        default:
            return state;
    }

};